/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class SeparatorClasses {
    static DEFAULT: string = 'default';

    static DESCRIPTION: string = 'description';

    static OPTIONS: string = 'options';
}
